import React, { useState } from "react";
import storage from "../assets/js/Global";

const Calendar = ({
  onDateChange,
  mode = "default",
  value,
  highlightedDates = [],
  maxDate = null,
}) => {
  const today = new Date();

  // Latest selectable instant (end of the maxDate day) — dates after this are disabled.
  const maxTime = maxDate
    ? new Date(
        maxDate.getFullYear(),
        maxDate.getMonth(),
        maxDate.getDate(),
        23,
        59,
        59,
        999,
      ).getTime()
    : null;

  const storedDate =
    mode === "default" ? storage.get("lastSelectedDate") : null;

  let parsedValueDate = null;
  const highlightedSet = new Set(highlightedDates);

  if (value) {
    const parts = value.split("/");
    if (parts.length === 3) {
      const [yyyy, mm, dd] = parts;
      parsedValueDate = new Date(`${yyyy}-${mm}-${dd}`);
    }
  }

  const initialDate =
    parsedValueDate || (storedDate ? new Date(parseInt(storedDate)) : today);

  const [currentMonth, setCurrentMonth] = useState(initialDate.getMonth());
  const [currentYear, setCurrentYear] = useState(initialDate.getFullYear());
  const [selectedDate, setSelectedDate] = useState(initialDate.getDate());

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Allow full range from 1900 to current year (or even future if desired)
  const minYear = 1900;
  const maxYear = maxDate ? maxDate.getFullYear() : today.getFullYear();

  const years = [];
  for (let y = minYear; y <= maxYear; y++) {
    years.push(y);
  }

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDay = new Date(currentYear, currentMonth, 1).getDay();

  const daysArray = [];
  for (let i = 0; i < firstDay; i++) daysArray.push(null);
  for (let i = 1; i <= daysInMonth; i++) daysArray.push(i);

  const handleDateSelect = (day) => {
    setSelectedDate(day);
    const dateObj = new Date(currentYear, currentMonth, day);

    if (mode === "default") {
      storage.set("lastSelectedDate", dateObj.getTime());
      onDateChange && onDateChange(dateObj);
    } else {
      const dd = String(day).padStart(2, "0");
      const mm = String(currentMonth + 1).padStart(2, "0");
      const yyyy = currentYear;
      onDateChange(`${yyyy}/${mm}/${dd}`);
    }
  };

  const prevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else setCurrentMonth(currentMonth - 1);
  };

  // With a maxDate, don't let the user page into a month past it.
  const isAtMaxMonth =
    maxDate &&
    currentYear === maxDate.getFullYear() &&
    currentMonth >= maxDate.getMonth();

  const nextMonth = () => {
    if (isAtMaxMonth) return;
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else setCurrentMonth(currentMonth + 1);
  };

  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <div className="calendar-container w-100">
        <div className="calendar-header mb-0">
          <div className="calender-btn" onClick={prevMonth}>
            <i
              className="fa-solid fa-angle-left"
              style={{ color: "#607D8B" }}
            ></i>
          </div>

          <div className="calendar-selectors">
            <select
              value={currentMonth}
              onChange={(e) => setCurrentMonth(Number(e.target.value))}
              className="py-1 form-select w-100"
            >
              {months.map((m, i) => (
                <option key={m} value={i}>
                  {m}
                </option>
              ))}
            </select>
            <select
              value={currentYear}
              onChange={(e) => setCurrentYear(Number(e.target.value))}
              className="py-1 form-select w-100"
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>

          <div
            className="calender-btn"
            onClick={nextMonth}
            style={
              isAtMaxMonth
                ? { opacity: 0.35, cursor: "not-allowed" }
                : undefined
            }
          >
            <i
              className="fa-solid fa-chevron-right"
              style={{ color: "#607D8B" }}
            ></i>
          </div>
        </div>

        <div className="calendar-weekdays mt-3">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
            <div key={d} className="weekday">
              {d}
            </div>
          ))}
        </div>

        <div className="calendar-days mt-2">
          {daysArray.map((day, idx) => {
            const dayDateString = day
              ? new Date(currentYear, currentMonth, day).toDateString()
              : "";
            const selectedDateString = new Date(
              currentYear,
              currentMonth,
              selectedDate,
            ).toDateString();

            const isSelected = dayDateString === selectedDateString;
            const isHighlighted =
              highlightedSet.has(dayDateString) && !isSelected;
            const isDisabled =
              day != null &&
              maxTime != null &&
              new Date(currentYear, currentMonth, day).getTime() > maxTime;

            return (
              <div
                key={idx}
                className={`day text-dark
                  ${isSelected ? "selected" : ""}
                  ${isHighlighted ? "highlighted" : ""}
                  ${isDisabled ? "disabled" : ""}`}
                onClick={() => day && !isDisabled && handleDateSelect(day)}
                style={
                  isDisabled
                    ? { opacity: 0.3, cursor: "not-allowed", pointerEvents: "none" }
                    : undefined
                }
              >
                {day && day}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Calendar;
